export default "__VITE_ASSET__xW7vXl2R__"